// Translations
var storeLang = document.querySelector('html').getAttribute('lang');
var textCart1 = 'Vai al carrello';
var textCart2 = 'aggiunto al carrello';

//console.log(storeLang);

if( storeLang == 'en' ){
  textCart1 = 'Go to cart';
  textCart2 = 'added to cart';
}

// Quick View
//jQuery.noConflict();
jQuery(document).ready(function() {
  jQuery.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function () {
      quickView();
  });
});

function quickView () {
    jQuery.noConflict()
    jQuery(".quick-view").click(function () {
        if (jQuery('#quick-view').length == 0) {
            jQuery("body").append('<div id="quick-view"></div>');
        }
        var product_handle = jQuery(this).data('handle');
        jQuery('#quick-view').addClass(product_handle);
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            var title = product.title;
            var type = product.type;
            var price = 0;
            var original_price = 0;
            var desc = product.description;
            var images = product.images;
            var variants = product.variants;
            var options = product.options;
            var url = '/products/' + product_handle;

            //console.log(product);

            //ID della prima variante per l'add to cart
            var productId = product.id;
            if (variants.length > 0) {
                productId = variants[0].id;
            }

            jQuery('.ProductMeta__Id').val(productId);
            jQuery('.ProductMeta__Title').text(title);
            jQuery('.qv-product-type').text(type);
            jQuery('.ProductMeta__Description .Rte').html(desc);
            jQuery('.view-product').attr('href', url);

            var imageCount = jQuery(images).length;
            jQuery(images).each(function (i, image) {
                /*if (i == imageCount - 1) {
                    var image_embed = '<div><img src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                    
                    $('.qv-product-images').append(image_embed);
                    try {
                        $('.qv-product-images').slick({
                            'dots': false,
                            'arrows': false,
                            'respondTo': 'min',
                            'useTransform': false
                        }).css('opacity', '1');
                    }catch (e) {
                        console.warn(e.message);
                    }
                } else {
                    image_embed = '<div><img src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

                    $('.qv-product-images').append(image_embed);
                }*/

                if (i == 0) {
                    image_embed = '<div><img src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

                    jQuery('.qv-product-images').append(image_embed);
                }
            });

            jQuery(options).each(function (i, option) {
                var opt = option.name;
                var optTrim = opt.trim();
                var optLower = opt.toLowerCase().trim();
                var selectClass = '.option.' + opt.toLowerCase().trim();

                // Custom variant DDP
                //console.log("option:", optLower);
                if( optLower != 'color' && optLower != 'colore' ){
                    jQuery('.qv-product-options').append('<ul class="SizeSwatchList optList option taglia"></ul>');
                }else{
                    jQuery('.qv-product-options').append('<ul class="ColorSwatchList optList option colore"></ul>');
                }

                // Ciclo le opzioni
                jQuery(option.values).each(function (i, value) {
                    var variantId = '';
                    var variantDisabled = true;
                    for (let j = 0; j < variants.length; j++) {
                        if (variants[j].title == value) {
                            variantId = variants[j].id;
                            variantDisabled = !(variants[j].available);
                            break;
                        }
                    }

                    // Verifica se colore o altro
                    if( optLower != 'color' && optLower != 'colore' ){
                        jQuery('.option.' + opt.toLowerCase()).append(
                            '<li class="HorizontalList__Item ' + (variantDisabled ? 'HorizontalList__Item--disabled' : '') + '">' +
                            '<input id="option-product-template-' + i + '-' + i + '" class="SizeSwatch__Radio" type="radio" ' + (variantDisabled ? 'disabled="disabled"' : '') + ' name="option-' + i + '" value="' + value + '" data-option-position="' + value + '" data-variant-id="' + variantId + '">' +
                            '<label for="option-product-template-' + i + '-' + i + '" class="SizeSwatch" style="'+ (variantDisabled ? 'cursor: not-allowed;' : '') + '">' + value + '</label>' + 
                            '</li>'
                        );
                    }else{
                        var img_name = value.replaceAll(". ", "-");
                        var all_spaces = img_name.replaceAll(" ", "-");
                        var final_name = all_spaces.replaceAll(/-{2,}/g, "-");
                        var remove_accent = final_name.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
    
                        /* FIX ** background-color: ' + value.replace(" ", "") + '; rimuovo -webkit-filter: grayscale(100%); filter: grayscale(100%); */
                        /* rimosso to lowee da remove_accent bg */
                        jQuery('.option.' + opt.toLowerCase()).append(
                            '<li class="HorizontalList__Item ' + (variantDisabled ? 'HorizontalList__Item--disabled' : '') + '">' +
                            '<input id="option-product-' + i + '-' + i + '" class="ColorSwatch__Radio" type="radio" ' + (variantDisabled ? 'disabled="disabled"' : '') + ' name="option-' + i + '" value="' + value + '" data-option-position="' + value.position + '" data-variant-id="' + variantId + '">' +
                            '<label for="option-product-' + i + '-' + i + '" class="ColorSwatch ColorSwatch--medium ColorSwatch--white" data-tooltip="' + value + '" style="background-image: url(https://cdn.shopify.com/s/files/1/0286/5712/3433/files/' + remove_accent + '_64x64.png); ' + (variantDisabled ? 'cursor: not-allowed;' : '') + '">' +
                            '<span class="u-visually-hidden">' + value + '</span>' +
                            '<span class="overlay"></span>' +
                            '</label>' +
                            '</li>'
                        );
                    }

                    // auto check first item available
                    var optList = document.querySelectorAll('.optList input');
                    for (let i = 0; i < optList.length; i++) {
                        if (optList[i].disabled == false) {
                            optList[i].checked = true;
                            break
                        }
                    }

                });
            });

            jQuery(product.variants).each(function (i, v) {
                if (v.inventory_quantity == 0) {
                    jQuery('.Button--quickview').prop('disabled', true).val('Sold Out');
                    jQuery('.qv-add-to-cart').hide();
                    jQuery('.ProductMeta__Price .money').text('Sold Out').show();
                    return true
                } else {
                    price = parseFloat(v.price / 100).toFixed(2);
                    original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

                    jQuery('.ProductMeta__Price .money').text('€' + price);
                    if (price > original_price && original_price > 0) {
                        jQuery('.qv-product-original-price').text('€' + original_price).show();
                    } else {
                        jQuery('.qv-product-original-price').hide();
                    }

                    jQuery('select.option-0').val(v.option1);
                    jQuery('select.option-1').val(v.option2);
                    jQuery('select.option-2').val(v.option3);
                    
                    return false;
                }
            });
        });

        // Modifica per color swatch list non funzionante
        var currentOpt = jQuery('#quick-view .optList input');
        var currentOptList = jQuery('#quick-view .optList li');

        /*if( !$('.optList').hasClass('colore') ){
            currentOpt = jQuery('#quick-view .SizeSwatchList input');
            currentOptList = jQuery('#quick-view .SizeSwatchList li');
        }*/

        // Change input option
        jQuery(document).on("change", currentOpt, function (e) {
            var selectedOptions = '';

            // Riabilito il bottone perchè seleziono una variante
            jQuery('.Button--quickview').prop('disabled', false);

            // Rimuovo il checkato precedentemente
            //currentOpt.removeAttr('checked');

            document.querySelectorAll('.optList input:checked').forEach(input => {
                input.checked = false;
            })
            jQuery(e.target).prop('checked', true);

            currentOptList.each(function (i) {
                if (selectedOptions == '') {
                    selectedOptions = jQuery(this).find('input[type="radio]').val();
                } else {
                    selectedOptions = selectedOptions + ' / ' + jQuery(this).find('input[type="radio]').val();
                }
                //console.log('selected', selectedOptions);
            });

            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                jQuery(product.variants).each(function (i, v) {
                    if (v.title == selectedOptions) {
                        var price = parseFloat(v.price / 100).toFixed(2);
                        var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                        var v_qty = v.inventory_quantity;
                        var v_inv = v.inventory_management;

                        jQuery('.ProductMeta__Price .money').text('$' + price);
                        jQuery('.qv-product-original-price').text('$' + original_price);

                        if (v_inv == null) {
                            jQuery('.Button--quickview').prop('disabled', false).val('Add to Cart');
                        } else {
                            if (v.inventory_quantity < 1) {
                                jQuery('.Button--quickview').prop('disabled', true).val('Sold Out');
                            } else {
                                jQuery('.Button--quickview').prop('disabled', false).val('Add to Cart');
                            }
                        }
                    }
                });
            });

        });
        

        // fancybox
        jQuery.fancybox({
            href: '#quick-view',
            maxWidth: 1040,
            maxHeight: 600,
            fitToView: true,
            width: '75%',
            height: '70%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            'afterLoad': function () {

                var observer = new MutationObserver(function () {

                    if (jQuery('#quick-view .optList input[type="radio"]').length == 0) {

                        // Disabilito pulsante perchè senza varianti
                        jQuery('.Button--quickview').prop('disabled', false);
                    }
                });
                observer.observe(document.getElementById('quick-view'), {
                    attributes: false,
                    childList: true,
                    characterData: false
                });

            },
            'beforeLoad': function () {
                var product_handle = jQuery('#quick-view').attr('class');

                jQuery(document).on("click", ".Button--quickview", function (e) {
                    var qty = jQuery('.qv-quantity').val();

                    let formData = {
                        items: []
                    };

                    if (jQuery('#quick-view .optList input[type="radio"]').length > 0) {

                        //Color palette
                        let variants = jQuery('#quick-view .optList input[type="radio"]:checked')
                            .map((i, el) => jQuery(el).data('variant-id'))
                            .get();

                        variants.forEach(variantId => {
                            formData.items.push({
                                id: variantId,
                                quantity: qty
                            });
                        });

                    } else {
                        formData.items.push({
                            id: jQuery('.ProductMeta__Id').val(),
                            quantity: qty
                        });
                    }

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData),

                    })
                        .then(response => {
                            jQuery('.qv-add-to-cart-response').addClass('success').html('<a class="Button Button--primary" href="/cart">' + textCart1 + '</a><span>' + jQuery('.ProductMeta__Title').text() + ' ' + textCart2 + '</span>');
                        })
                        .catch((error) => {
                            jQuery('.qv-add-to-cart-response').addClass('error').html('<span>' + error + '</span>');
                        });

                });
                // Hidden
                jQuery('.fancybox-wrap').css('overflow', 'hidden !important');
            },
            'afterShow': function () {
                jQuery('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
                    jQuery('.qv-product-images').addClass('loaded');
                });
            },
            'afterClose': function () {
                jQuery('#quick-view').removeClass().empty();
            }
        });
    });

    // Increase and decrease
    jQuery(document).on('click', '#quick-view [data-action=increase-quantity]', function () {
        var $qty = jQuery(this).closest('.QuantitySelector').find('[name=quantity]');
        var currentVal = parseInt($qty.val());
        if (!isNaN(currentVal)) {
            $qty.val(currentVal + 1);
        }
    });

    jQuery(document).on('click', '#quick-view [data-action=decrease-quantity]', function () {
        var $qty = jQuery(this).closest('.QuantitySelector').find('[name=quantity]');
        var currentVal = parseInt($qty.val());
        if (!isNaN(currentVal) && currentVal > 0) {
            $qty.val(currentVal - 1);
        }
    });

};

/*jQuery.noConflict();
jQuery(window).resize(function($) {
    if ($('#quick-view').is(':visible')) {
        //$('.qv-product-images').slick('setPosition');
    }
});*/